module.exports = __webpack_public_path__ + "images/800x800_Individual_0000s_0002_Suso_Orange-&-Madarin_2.png";